var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftwareLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: 22.034,
    y1: 9.773,
    x2: 17.118,
    y2: 14.842,
    gradientTransform: "scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira-original-b",
    gradientUnits: "userSpaceOnUse",
    x1: 16.641,
    y1: 15.564,
    x2: 10.957,
    y2: 21.094,
    gradientTransform: "scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.023 16H61.805c0 11.52 9.324 20.848 20.847 20.848h8.5v8.226c0 11.52 9.328 20.848 20.848 20.848V19.977A3.98 3.98 0 00108.023 16zm0 0",
    fill: "#2684ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.121 39.04H38.902c0 11.519 9.325 20.847 20.844 20.847h8.504v8.226c0 11.52 9.328 20.848 20.848 20.848V43.016a3.983 3.983 0 00-3.977-3.977zm0 0",
    fill: "url(#jira-original-a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.219 62.078H16c0 11.524 9.324 20.848 20.848 20.848h8.5v8.23c0 11.52 9.328 20.844 20.847 20.844V66.059a3.984 3.984 0 00-3.976-3.98zm0 0",
    fill: "url(#jira-original-b)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareLogo);
export default __webpack_public_path__ + "static/media/software-logo.b894f17b42eb499ba8a4c4cecbb58a99.svg";
export { ForwardRef as ReactComponent };